import { PROJECTS } from "@/lib/constants";
import { ArrowUpRight } from "lucide-react";

export const Projects = () => {
    return (
        <section
            id="projects"
            data-testid="projects-section"
            className="relative bg-bone py-24 md:py-32 border-t border-line"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12 md:mb-16">
                    <div className="reveal max-w-2xl">
                        <div className="text-xs uppercase tracking-[0.25em] font-bold text-terracotta mb-5">
                            <span className="inline-block w-8 h-px bg-terracotta align-middle mr-3" />
                            Selected Projects
                        </div>
                        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter font-medium text-ink leading-[1.02]">
                            Recent work in <br /> Utah HOA communities.
                        </h2>
                    </div>
                    <p className="reveal text-base text-stone max-w-sm leading-relaxed">
                        Real H2No installs across various new-construction neighborhoods
                        along the Wasatch Front.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {PROJECTS.map((p, i) => (
                        <article
                            key={p.title}
                            data-testid={`project-card-${i}`}
                            className="reveal group cursor-pointer"
                            style={{ transitionDelay: `${i * 80}ms` }}
                        >
                            <div className="relative overflow-hidden border border-line bg-ink aspect-[4/5]">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent" />
                                <div className="absolute top-4 right-4 h-9 w-9 bg-bone/95 flex items-center justify-center group-hover:bg-terracotta transition-colors">
                                    <ArrowUpRight size={16} className="text-ink group-hover:text-bone transition-colors" />
                                </div>
                                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                                    <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-terracotta mb-1.5">
                                        {p.category}
                                    </div>
                                    <h3 className="font-heading text-lg md:text-xl font-medium text-bone leading-tight">
                                        {p.title}
                                    </h3>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="reveal mt-12 md:mt-16 border-t border-line pt-8 text-center">
                    <p className="text-sm text-stone">
                        Looking for a specific scope reference? Email{" "}
                        <a href="mailto:sales@h2noutah.com" className="text-ink underline hover:text-terracotta">
                            sales@h2noutah.com
                        </a>{" "}
                        — we'll send recent jobs that match yours.
                    </p>
                </div>
            </div>
        </section>
    );
};
